import { render } from "./termsOfService.vue?vue&type=template&id=2788e298&scoped=true"
import script from "./termsOfService.vue?vue&type=script&lang=js"
export * from "./termsOfService.vue?vue&type=script&lang=js"

import "./termsOfService.vue?vue&type=style&index=0&id=2788e298&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2788e298"]])

export default __exports__